import { createGlobalStyle } from "styled-components";

export const QuestionCss = createGlobalStyle`
    .parent-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-family: sans-serif;
        height: 100%;
        width: 100%;
    }
    .question-card {
        background: #ffffff;
        padding: 3rem 5rem;
        border-radius: 2rem;
        box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.5);
        width: 80%;
    }

    .question-card p {
        padding-top: 1rem;
        font-size: 16px;
    }

    .question-content {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2px;
    }

    .answers-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        font-size: 16px;
    }

    .success-msg {
        color: green;
        font-size: 22px;
    } 
`;
